import { Component } from '@angular/core';
import {SlideshowService} from '../slideshow.service';

@Component({
    selector: 'preview-component',
    templateUrl: 'preview.component.html'
})
export class PreviewComponent {
    device = 'desktop';

    constructor(private slideshow: SlideshowService) {}
    toggle(device) {
        this.device = device;
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/tabs/preview.component.ts